import React from 'react';
import i18n from '../../../../../i18n';
import { fmt } from '../../../data/metrics';
import type { DrillSellShiftMix } from '../../../types';
import { DrillTile } from './DrillTile';
import { countLabel } from './substanceFormat';

const T = 'performance:drillSell.mix';
const TOP = 5;

export function DrillSellShiftMixSection({
  data,
  fmtMoney,
}: {
  metricKey: string;
  data: DrillSellShiftMix;
  fmtMoney: (v: number) => string;
}) {
  if (!data.shifts.length) return null;
  const reservations = data.shifts.reduce((n, s) => n + s.reservations, 0);
  return (
    <DrillTile
      sectionId="sell-shift-mix"
      span={8}
      title={i18n.t(`${T}.title`)}
      meta={countLabel(`${T}.reservations`, reservations)}
    >
      <div className="dsub-shift-grid">
        {data.shifts.map(s => (
          <div key={s.key}>
            <div className="dsub-shift-head">
              <span>{s.label ?? i18n.t(`${T}.noShift`)}</span>
              <span className="dsub-n">
                {fmtMoney(s.revenue)} · {countLabel(`${T}.reservations`, s.reservations)}
              </span>
            </div>
            <ul className="dsub-items">
              {s.items.map(it => (
                <li key={`${it.name}-${it.emoji ?? ''}`}>
                  <span className="dsub-item-name" title={it.name}>
                    {it.emoji ? `${it.emoji} ` : ''}
                    {it.name}
                  </span>
                  <span className="dsub-n">{fmt.num(it.qty)}×</span>
                  <span>{fmtMoney(it.revenue)}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {data.more > 0 ? (
        <p className="dsub-n">{i18n.t(`${T}.more`, { count: data.more })}</p>
      ) : null}
      <p className="ddrill-tile-note">{i18n.t(`${T}.basis`, { count: TOP })}</p>
    </DrillTile>
  );
}
